document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('loadMoreProjects');

    if (!button) return;

    const items = document.querySelectorAll('.hidden-project');
    let currentIndex = 0;
    const step = 4;

    button.addEventListener('click', function () {

        const nextItems = Array.from(items).slice(currentIndex, currentIndex + step);

        nextItems.forEach((item, index) => {
            setTimeout(() => {
                item.classList.add('show');
            }, index * 120);
        });

        currentIndex += step;

        // Hide button when no more items
        if (currentIndex >= items.length) {
            button.style.display = 'none';
        }
    });
});